import React from 'react';

export type FilterFieldType =
  | 'string'
  | 'number'
  | 'date'
  | 'select'
  | 'radio'
  | 'checkbox';
export type FilterOperator =
  | 'eq'
  | 'neq'
  | 'contains'
  | 'lte'
  | 'gte'
  | 'between';

export const FilterOperatorDef: any = {
  eq: 'Equals',
  neq: 'Not Equals',
  contains: 'Contains',
  lte: 'Less than or equals',
  gte: 'Greater than or equals',
  between: 'Between',
};

export type FilterSelectOption = {
  value: string | number;
  label: React.ReactNode;
};
export type FilterField = {
  name: string;
  label: string;
  type: FilterFieldType;
  operators: FilterOperator[];
  options?: FilterSelectOption[];
  hidden?: boolean;
  props?: any;
  masterDataType?:
    | 'suburbs'
    | 'council'
    | 'states'
    | 'user'
    | 'zone'
    | 'site'
    | 'collectionType';
  disabled?: boolean;
  disabledReason?: string;
};

export type FilterFields = FilterField[];
export type FilterFieldValue = string | number | string[] | number[];

export type FilterValue = {
  name: string;
  operator: FilterOperator;
  value: FilterFieldValue;
};

export type FilterValues = FilterValue[];
